/* eslint-disable jsx-a11y/no-static-element-interactions */
type Props = {
  id: number;
  values: string[];
  selectedValues: string[];
  handleAdditionalCRMCheck: (id:number, value: string) => void
};

const AdditionalCRMFieldsFilter = ({ id, values, selectedValues, handleAdditionalCRMCheck }: Props) => {
  return (
    <div>
      {values &&
        values.map((value, idx) => (
          <div
            key={idx}
            className="flex justify-start py-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleAdditionalCRMCheck(id, value);
            }}
          >
            <input
              type="checkbox"
              checked={selectedValues?.includes(value)}
              className="form-checkbox h-3.5 w-3.5 lg:h-4 lg:w-4 text-secondary focus:ring-transparent cursor-pointer rounded-sm border-secondary"
              name={value}
              value={value}
              id={value}
            />
            <h4 className="text-primary-dark text-xs lg:text-sm font-medium leading-4 mx-2">
              {value}
            </h4>
          </div>
        ))}
    </div>
  );
};

export default AdditionalCRMFieldsFilter;
